import React, { Suspense } from 'react';
import { Redirect } from 'react-router';
import { makeStyles } from '@material-ui/styles';
import { LinearProgress } from '@material-ui/core';
import { useSelector } from 'react-redux';
import Topbar from './Topbar';

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: '100vh',
    display: 'flex',
    '@media all and (-ms-high-contrast:none)': {
      height: 0, // IE11 fix
    },
  },
  content: {
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 56,
    },
  },
}));

function Auth({ children }) {
  const classes = useStyles();
  const signedIn = useSelector((state) => state.user.profile != null);
  if (!signedIn) {
    return (
      <Redirect to={`/auth/login?returnTo=${encodeURIComponent(window.location.pathname + window.location.search)}`} />
    );
  }
  return (
    <>
      <Topbar />
      <div className={classes.container}>
        <div className={classes.content}>
          <Suspense fallback={<LinearProgress />}>{children}</Suspense>
        </div>
      </div>
    </>
  );
}

export default Auth;
